import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { whatIDo } from "../../data/profile";

export default function WhatIDo() {
  return (
    <Container fluid className="what-i-do-section">
      <Container>
        <motion.h1
          className="project-heading"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          What I <strong className="purple">Do</strong>
        </motion.h1>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {whatIDo.map((block, idx) => (
            <Col key={block.title} md={6} lg={6} className="what-i-do-col">
              <motion.div
                className="what-i-do-card"
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.5, ease: "easeOut", delay: idx * 0.05 }}
              >
                <div className="what-i-do-title">{block.title}</div>
                <ul className="what-i-do-points">
                  {block.points.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

